/**
 * What the trial activation page (/start, alias /trial) tells search engines and link previews — ONE copy, read by
 * today's page (src/pages/StartTrial.tsx) and its rebuild in the new design, the way src/config/pricingSeo.ts serves
 * both pricing pages (design record §7b).
 *
 * THE SHAPE IS READ BY THE GUEST CHAT'S KNOWLEDGE SOURCE (scripts/generate-guest-knowledge-source.mjs lists this file
 * for "/start"): its extractor takes a `title:` / `description:` field whose string sits on the same line, so each
 * stays one line.
 */
export const START_SEO = {
  title: 'Start Your Trial — prest0',
  description: 'Get started with prest0 — activate your access code and put an AI employee to work for your team, with PRO Work Units included from day one.',
  canonicalUrl: 'https://prest0.ai/start',
  keywords: 'prest0 trial, AI employee trial, enterprise AI trial, AI assistant for teams, legal AI trial, finance AI trial',
} as const;
